<template>
  <router-link :to="fields.route">
    <div
      class="card-emendas bg form-group"
      :style="{
        backgroundImage:
          'url(' + require(`@/assets/css/img/${fields.icon}`) + ')'
      }"
    >
      <div class="context">
        <span class="title">{{ fields.nome }}</span>
        
        <div class="details">
          <div class="progress-container">
            <div class="progress-bar" :style="{ width: fields.percentual + '%'}"></div>
          </div>
          <span class="percentual-text">{{ fields.percentual }}% Concluído</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      default: {
        route: '#',
        nome: 'título',
        icon: 'ico-servidor.svg'
      }
    }
  },

  computed: {
    fields() {
      return {
        ...this.default,
        ...this.item
      }
    }
  }
}
</script>

<style scoped>
.card-emendas {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 1px 10px 1px;
  transition: all ease 200ms;
  background-repeat: no-repeat;
  background-size: 80% 80%;
  background-position: center;
  opacity: 0.5;
  font-size: 1.6em;
}

a:hover .card-emendas {
  box-shadow: 0 4px 5px 2px #e8e8e8, 0 2px 1px 1px #d8d8d8;
  transform: translateY(-4px);
}

.card-emendas .context {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.9);
}

.card-emendas .context .title {
  width: 100%;
  font-weight: 600;
  font-size: .7em;
}

.details {
  font-size: 0.8em;
  width: 100%;
  padding: 8px;
  text-transform: none;
}

.info-geral {
  margin-bottom: 8px;
}

.progress-container {
  background-color: #e0e0e0;
  border-radius: 10px;
  height: 12px;
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
}

.progress-bar {
  background-color: #29c402;
  height: 100%;
  border-radius: 10px;
  transition: width 0.5s ease-in-out;
}

.percentual-text {
  font-weight: bold;
  font-size: 0.7em;
  display: block;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/InstitucionalNomeValor.vue